/**
 * 
 */

import { createSlice } from '@reduxjs/toolkit';

let selected_GW
const _gateway = localStorage.getItem('ipfs_gateway')===null?'ipfs.io':localStorage.getItem('ipfs_gateway')
if(_gateway===void 0){
    localStorage.setItem('ipfs_gateway', 'ipfs.io')
    selected_GW = 'ipfs.io'
}
else {
    selected_GW = _gateway
}

export const IPFS_Slice = createSlice({
    name: 'IPFS_State',
    initialState: {
        selected_GW:selected_GW,
        gateway:{
            g1: "ipfs.io",
            g2: "dweb.link",
            g3: "gateway.pinata.cloud",
            g4: "4everland.io",
            g6: "gateway.q-66.com",
            g7: "172.16.255.2:8080",
            g8: "qwertyui.vip:8080",
        },
    },
    reducers: {
        // 改值
        change_GW: (state, data) => {
            state.selected_GW=data.payload // 将修改的参数data.payload赋值给初始化中的selected_GW
            localStorage.setItem('ipfs_gateway', data.payload)
        }
    },
});

// 为每个 case reducer 函数生成 Action creators
export const { change_GW } = IPFS_Slice.actions;

export default IPFS_Slice.reducer;